import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Laura M. & Max (Golden Retriever, 9 años)',
    text: "Pensé que los problemas articulares de Max eran 'cosas de la edad'. A los 10 días de aplicar el método, volvió a subir al sofá sin ayuda. Lloré de alegría al verlo correr de nuevo en el parque.",
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Carlos R. & Luna (Gata Siamesa, 5 años)',
    text: 'Luna sufría de problemas renales recurrentes. Desde que cambiamos su alimentación siguiendo la guía, sus últimos análisis salieron perfectos. El veterinario no lo podía creer.',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Ana P. & Rocky (Bulldog Francés, 3 años)',
    text: 'Las alergias en la piel de Rocky nos tenían desesperados (y gastando una fortuna en cremas). El Método Bio-Vital curó su piel desde adentro. Su pelaje ahora brilla como nunca.',
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="py-24 bg-cream" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-178">
            Cartas de amor de{' '}
            <span className="text-sage-dark italic" data-id="element-179">Pet Parents</span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-180">
            Historias reales de transformación que nos llenan el corazón.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-181">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-3xl p-8 shadow-soft relative mt-8" data-id="element-182">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2" data-id="element-183">
                <div className="w-16 h-16 rounded-full border-4 border-white shadow-md overflow-hidden" data-id="element-184">
                  <img src={t.img} alt={t.name} className="w-full h-full object-cover" data-id="element-185" />
                </div>
              </div>

              <Quote className="w-8 h-8 text-sage-light/50 mx-auto mt-6 mb-4" data-id="element-186" />

              <p className="text-gray-700 text-center mb-6 italic leading-relaxed" data-id="element-187">
                "{t.text}"
              </p>

              <div className="text-center" data-id="element-188">
                <p className="font-bold text-gray-900 text-sm" data-id="element-189">{t.name}</p>
                <div className="flex justify-center mt-2 text-terracotta" data-id="element-190">
                  {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-191">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-192" />
                    </svg>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}